import apiClient from "@/axios.js";
import endpoints from "@/endpoints";
import axios from "axios";
const PREPR_API = process.env.VUE_APP_PREPR_API;

export async function getBakersResult(barcode) {
  const { data } = await apiClient.get(endpoints.BakersResult(barcode), {});
  return data;
}

export async function getBakersdetailResult(barcode) {
  const { data } = await apiClient.get(endpoints.BakersdetailResult(barcode), {});
  return data;
}
export async function getBakersPublicDetailResult(uuid) {
  const { data } = await apiClient.get(endpoints.BakersPublicDetailResult(uuid), {});
  return data;
}

export async function getBakersprofilebyuid(barcode) {
  const { data } = await apiClient.get(endpoints.publicProfile(barcode), {});
  return data;
}

export async function getBakersoverviewproduct(id) {
  try {

    const res = await axios.post(PREPR_API, {
      query: `
  {     

       ProductGrouping(slug: "${id}") {
                id
                _slug
                description
                content_reference {
                ... on CitationModel {
                        id
                        title
                        external_url
                }
             }
           }
  }
  `
    });

    //alert(JSON.stringify(res.data?.data?.ProductGrouping));
    const model = res?.data?.data?.ProductGrouping;

    if (!model) {
      if (res.data.errors) console.error("GraphQL Errors:", res.data.errors);
      return null;
    }

    return {
      ...model,

    };

  } catch (error) {
    console.error("API Error:", error);
    return null;
  }
}

export async function getBakersphenotype(subcat) {
  try {
    const value = subcat;
    const slugeddata = value.split(":")[0];
    const slugPart = value.split(":")[1];
    const slugPartvalue = slugPart?.split("-").map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(" ");

    const res = await axios.post(PREPR_API, {
      query: `
  {
    WellbeingPhenotypeModels(
      where: {
       
        related_to_trait_slug: "${slugeddata}"
         result: "${slugPartvalue}"
      }
    ) {
      items {
        title
        related_to_trait
        related_to_trait_slug
        result
        position_on_scale
        advice_one_liner_text
        advice_definition
        key_takeaway
        positive_points
        warning_points
        considerations
        advice_by
        influencing_genetics
        take_away_image {
          url
        }
      }
    }
  }
  `
    });


    const model = res?.data?.data?.WellbeingPhenotypeModels?.items[0];

    if (!model) {
      if (res.data.errors) console.error("GraphQL Errors:", res.data.errors);
      return null;
    }

    return {
      ...model,

    };

  } catch (error) {
    console.error("API Error:", error);
    return null;
  }
}

export async function getBakersresultstatus(subcat, phenotype) {
  try {

    const phenotypestatus = phenotype.charAt(0).toUpperCase() + phenotype.slice(1);
    console.log(phenotypestatus);
    const value = subcat;
    const slugeddata = value.split(":")[0];

    if (!slugeddata) {
      console.error("No phenotype ID matched");
      return null;
    }

    const res = await axios.post(PREPR_API, {
      query: `
  {
    WellbeingPhenotypeModels(
      where: {
        related_to_trait_slug: "${slugeddata}"
         result: "${phenotypestatus}"
      }
    ) {
      items {
        title
        related_to_trait
        related_to_trait_slug
        result
        position_on_scale
        advice_one_liner_text
        advice_definition
        key_takeaway
        positive_points
        warning_points
        considerations
        advice_by
        influencing_genetics
        take_away_image {
          url
        }
      }
    }
  }
  `
    });

    const model = res?.data?.data?.WellbeingPhenotypeModels?.items[0];

    if (!model) {
      if (res.data.errors) console.error("GraphQL Errors:", res.data.errors);
      return null;
    }

    return {
      ...model,

    };

  } catch (error) {
    console.error("API Error:", error);
    return null;
  }
}

export async function getBakersdescription(subcat) {
  try {
    const value = subcat;
    const slugeddata = value.split(":")[0];

    if (!slugeddata) {
      console.error("No phenotype ID matched");
      return null;
    }

    const res = await axios.post(PREPR_API, {
      query: `
              {
                WellbeingTraitModel(slug: "${slugeddata}") {
                  title
                  heading
                  definition_link_name
                  definition
                  limitations
                  expert_advice
                  main_image {
                    url
                  }
                  science_of_heading
                  science_of_introduction
                  science_of_image {
                    url
                  }
                  population_distribution
                  references {
                    id
                    title
                    external_url
                  }
                  related_traits
                  goals
                  trait_effects_title
                  trait_effect_1
                  trait_effect_1_image {
                    url
                  }
                  trait_effect_2
                  trait_effect_2_image {
                    url
                  }
                  
                  trait_effect_3
                  trait_effect_3_image {
                    url
                  }
                  
                }
              }
              `
    });


    const model = res?.data?.data?.WellbeingTraitModel;

    if (!model) {
      if (res.data.errors) console.error("GraphQL Errors:", res.data.errors);
      return null;
    }

    return {
      ...model,

    };

  } catch (error) {
    console.error("API Error:", error);
    return null;
  }
}

export async function getBakersvaluetitle(subcat) {
  try {
    const traitMap = {
      'Bitter Perception': '8ca71a06-39cd-4e70-9ea1-90779baed661',
      'Fat Perception': '0fcd858a-9cfe-465b-a7b5-94a84ae737ab',
      'Salt Taste Sensitivity': '20b21b23-f381-44bb-943a-8489afba8083',
      'Umami Taste Sensitivity': '3f9f5b4d-e0e7-4e4b-8cb3-b465cb882737',
      'Sour Taste Sensitivity': '3a2f1110-c9de-4bf7-9ca9-36c21c37849e',
      'Sweet Sensitivity': '583fb44a-01fa-44b2-9c02-305ff204c327',
      'Sweet Taste Preference': 'b76754be-556c-4b85-8d67-fd2c68386d9e',
      'Vanilla Smell Sensitivity': '673e6da0-48e2-4d6d-8209-e33927aa957e',
      'Beta-ionone Sensitivity': '3cfeb1cf-e446-4ab1-b0b1-516709d65f80',
      'Cinnamon Smell Sensitivity': '14463169-d675-4c5e-aa79-3f7de2f8ea46',
      'Liquorice Smell Sensitivity': 'ac55dfd6-9c17-4690-aac5-1573f1eca02e',
      'C3HEX Smell Sensitivity': 'f75a5339-a300-4d11-8a28-42d592953525',
      'Caffeine Metabolism': '95e13415-7d74-4bcf-9f2c-68af278a3470',

      'Gluten Metabolism': '26c09651-3b0c-4fda-86e5-9bd5d632ad8b',
      'Lactose Metabolism': '4e99bc54-880c-491d-b865-cbc796f6c35c',
      'Starch Metabolism': 'e746fc06-bf4d-48df-bb0d-4c0d5980440b',
      'Grip & Power': '9d8730ea-cd8c-4e6d-8ce2-e0189105190e',
      'Heat & Pain Tolerance': '372cf6e4-c5be-4cde-a9b8-a3f6159ab309',
      'Motor Learning Plasticity': 'f08eb4fc-b5a3-4e71-808f-63bce1e3724d',
      'Motor Control': '6a11917b-07b6-4001-a473-dec71f24365d',

    };

    const id = traitMap[subcat] || '8ca71a06-39cd-4e70-9ea1-90779baed661';

    const res = await axios.post(PREPR_API, {
      query: `
              {
              
                 WellbeingTraitModel(id: "${id}") {
                  title
                  heading
                  definition_link_name
                  definition
                  limitations
                  expert_advice
                  main_image {
                    url
                  }
                  science_of_heading
                  science_of_introduction
                  science_of_image {
                    url
                  }
                  population_distribution
                  references {
                    id
                    title
                    external_url
                  }
                  related_traits
                  goals
                  trait_effects_title
                  trait_effect_1
                  trait_effect_1_image {
                    url
                  }
                  trait_effect_2
                  trait_effect_2_image {
                    url
                  }
                  
                  trait_effect_3
                  trait_effect_3_image {
                    url
                  }
                  
                }
              }
              `
    });


    const model = res?.data?.data?.WellbeingTraitModel;

    if (!model) {
      if (res.data.errors) console.error("GraphQL Errors:", res.data.errors);
      return null;
    }

    return {
      ...model,

    };

  } catch (error) {
    console.error("API Error:", error);
    return null;
  }
}

export async function getBakerscategoryintrodction(category) {
  const res = await axios.post(PREPR_API, {
    query: `
      {
        ProductPageTabs(where: { name: "${category}" }) {
          items {
            _id
            name
            body
            icon {
              url
            }
            image {
              url
            }
          }
        }
      }
    `
  });

  return res.data.data.ProductPageTabs.items[0] || null;
}

export async function getBakersIntroduction() {
  const res = await axios.post(PREPR_API, {
    query: `{
                CommonModel (slug: "epigenetic-overview") { 
                        title
                        heading
                        text
                        main_image { 
                                url
                        }
                        right_section { 
                                title
                                heading
                                text
                                main_image {
                                        url
                                }
                                button_text
                        }
                }
                }`
  });
  return res.data.data.CommonModel
}

export async function getBakersUnlock() {
  const res = await axios.post(PREPR_API, {
    query: `{
      CommonUnlock (slug: "unlock-bakers") { 
          title
          banner { 
                  title
                  heading
                  image { 
                          url
                  }
                  text
                  button_text
          }
          description { 
                  title
                  heading
                  image { 
                          url
                  }
                  text
          }
        }
      }`
  });
  return res.data.data.CommonUnlock;
}

export async function getBakersUpgrade() {
  const res = await axios.post(PREPR_API, {
    query: `{
      CommonUpgrade (slug: "viking-upgrade") { 
        _id
        heading
        title
        content { 
          title
          heading
          image {
                  url
          }
          text
          button_text
        }
        description
        faqs { 
          question
          answer
        }
      }
    }`
  });
  return res.data.data.CommonUpgrade;
}